module.exports = __webpack_public_path__ + "img/Logo.103d5d6c.svg";